module.exports = __webpack_public_path__ + "static/img/1_0034.ad0eedb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0034.jpg
// module id = IbzM
// module chunks = 0